import { render, staticRenderFns } from "./iPadLogoBox.vue?vue&type=template&id=6128a249&scoped=true&"
import script from "./iPadLogoBox.vue?vue&type=script&lang=js&"
export * from "./iPadLogoBox.vue?vue&type=script&lang=js&"
import style0 from "./iPadLogoBox.vue?vue&type=style&index=0&id=6128a249&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6128a249",
  null
  
)

export default component.exports